import {mapGetters} from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtSaleProceeds from '@/common/components/mvtsaleproceeds/mvt-saleproceeds.vue';

export default {
    name: 'propertySaleProceeds',
    data() {
        return {
            disableCollapse: false,
            netProceeds: 0
        };
    },
    components: {
        mvtCollapse,
        mvtSaleProceeds
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getEstPrice', 'getAvmValuation']),
    },
    props: ['isActive'],
    methods: {
        updateNetProceeds(value) {
            this.netProceeds = value
        }
    }
};
